// // import React from "react";
// // import { IoWalletOutline } from "react-icons/io5";

// // function Paid({ isMarkAsPaidDisabled, onPressMarkAsPaid = () => {} }) {
// //   const divStyle = {
// //     height: "1.5rem", // h-6
// //     width: "5rem", // w-20
// //     borderRadius: "9999px", // rounded-full
// //     backgroundColor: "transparent", // bg-red-500
// //     borderWidth: "1px", // border-solid
// //     borderColor: "blue", // border-solid
// //     borderStyle: "solid", // border-solid
// //     display: "flex",
// //     justifyContent: "center",
// //     alignItems: "center",
// //     gap: 2,
// //     cursor: "pointer",
// //     color: "blue", // Updated text color to blue
// //   };

// //   const textStyle = {
// //     color: "blue", // Updated text color to blue
// //     cursor: "pointer",
// //   };

// //   return (
// //     <div style={divStyle}>
// //       <IoWalletOutline size={15} />
// //       <button
// //         onClick={onPressMarkAsPaid}
// //         style={textStyle}
// //         disabled={isMarkAsPaidDisabled}
// //       >
// //         Paid
// //       </button>
// //     </div>
// //   );
// // }

// // export default Paid;

// // src/components/YourPath/Paid.jsx

// import React from "react";
// import { IoWalletOutline } from "react-icons/io5";

// // 1. Accept the new `isDisabled` prop
// function Paid({
//   isMarkAsPaidDisabled,
//   onPressMarkAsPaid = () => {},
//   isDisabled,
// }) {
//   // 2. Create a single variable for the final disabled state
//   const finalDisabledState = isMarkAsPaidDisabled || isDisabled;

//   // Base styles remain the same
//   const divStyle = {
//     height: "1.5rem",
//     width: "5rem",
//     borderRadius: "9999px",
//     backgroundColor: "transparent",
//     borderWidth: "1px",
//     borderStyle: "solid",
//     borderColor: "blue",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "0.5rem", // Use rem for consistency
//     cursor: "pointer",
//     color: "blue",
//     transition: "all 0.2s ease-in-out", // Add a nice transition
//   };

//   // 3. Define the styles for the disabled state
//   const disabledStyle = {
//     borderColor: "#a0aec0", // gray-400
//     color: "#a0aec0",
//     cursor: "not-allowed",
//     opacity: 0.8, // Slightly more visible than a fully disabled row
//     borderStyle: "dotted", // THE KEY CHANGE
//   };

//   // 4. Merge the base and disabled styles conditionally
//   const finalDivStyle = {
//     ...divStyle,
//     ...(finalDisabledState ? disabledStyle : {}),
//   };

//   const textStyle = {
//     color: "inherit", // Inherit color from the parent div
//     cursor: "inherit", // Inherit cursor from the parent div
//   };

//   return (
//     // Apply the final, merged style object here
//     <div style={finalDivStyle}>
//       <IoWalletOutline size={15} />
//       <button
//         onClick={onPressMarkAsPaid}
//         style={textStyle}
//         // Use the final disabled state for the button
//         disabled={finalDisabledState}
//       >
//         Paid
//       </button>
//     </div>
//   );
// }

// export default Paid;

// src/components/YourPath/Paid.jsx

// src/components/YourPath/Paid.jsx

// src/components/YourPath/Paid.jsx
import React from "react";
import { IoWalletOutline } from "react-icons/io5";

function Paid({
  isMarkAsPaidDisabled,
  onPressMarkAsPaid = () => {},
  isDisabled,
}) {
  const finalDisabledState = isMarkAsPaidDisabled || isDisabled;

  // The 'group' class here makes this button a self-contained hover target.
  const baseButtonStyles =
    "group flex items-center justify-center w-24 h-6 gap-1.5 text-xs font-medium border rounded-full transition-all duration-300";

  const enabledStyles =
    "border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 cursor-pointer";

  const disabledStyles =
    "border-gray-400 text-gray-400 border-dotted opacity-80 cursor-not-allowed";

  const iconColor = finalDisabledState
    ? "text-gray-400"
    : "text-blue-500 group-hover:text-white";

  return (
    <button
      onClick={onPressMarkAsPaid}
      disabled={finalDisabledState}
      className={`${baseButtonStyles} ${finalDisabledState ? disabledStyles : enabledStyles}`}
    >
      <IoWalletOutline
        size={15}
        className={`transition-colors duration-300 ${iconColor}`}
      />
      {/* This group-hover now correctly refers to hovering this specific button */}
      <span className="group-hover:text-white transition-colors duration-300">
        Paid
      </span>
    </button>
  );
}

export default Paid;
